// extracted by mini-css-extract-plugin
export default {"table":"WorklistUploadModal-styles-module--table--TCDKN"};